// L'accueil — « jour → nuit » (9 octobre 2026).
//
// La page raconte une seule idée : toi ce matin poses le verrou, toi à 2 h 47
// le trouves fermé. Le défilement suit la journée :
//   hero (matin, le film) → la frise de la journée → la nuit (ce qui a raté,
//   barré au marqueur) → comment ça marche → le téléphone annoté →
//   comparatif → le pari à 100 $ → cashback → confidentialité → tarifs →
//   FAQ → guides → retour à la nuit : « Tonight, it's already locked ».
import { useRef } from 'react'
import Navbar from '../components/urself/Navbar'
import Footer from '../components/urself/Footer'
import Hero from '../components/landing/Hero'
import Day from '../components/landing/Day'
import Facts from '../components/landing/Facts'
import Problem from '../components/landing/Problem'
import How from '../components/landing/How'
import Inside from '../components/landing/Inside'
import Rivals from '../components/landing/Rivals'
import Bet from '../components/landing/Bet'
import Rewards from '../components/landing/Rewards'
import Privacy from '../components/landing/Privacy'
import Plans from '../components/landing/Plans'
import Voices from '../components/landing/Voices'
import TryIt from '../components/landing/TryIt'
import Faq from '../components/landing/Faq'
import GuidesTeaser from '../components/landing/GuidesTeaser'
import EndCta from '../components/landing/EndCta'
import StickyCta from '../components/landing/StickyCta'
import Relay from '../components/landing/Relay'
import { useT } from '../lib/i18n'
import { useSeo, organizationLd, websiteLd, softwareLd, faqLd, videoLd } from '../lib/seo'
import useReveal from '../lib/useReveal'

export default function Home () {
  const t = useT()
  const page = useRef(null)
  useReveal(page)

  useSeo({
    title: t.seo.home.title,
    description: t.seo.home.description,
    path: '/',
    bare: true,
    jsonLd: [
      organizationLd(),
      websiteLd(),
      softwareLd(t.seo.home.description),
      videoLd(),
      faqLd(t.faq.items)
    ]
  })

  return (
    <div className="lp" ref={page}>
      <Navbar />
      <main>
        <Hero />
        <Facts />
        <Day />
        <TryIt />
        <Problem />
        <Voices />
        <Relay line={t.relay.afterProblem} />
        <How />
        <Inside />
        <Relay line={t.relay.afterInside} />
        <Rivals />
        <Bet />
        <Rewards />
        <Privacy />
        <Plans />
        <Faq />
        <GuidesTeaser />
        <EndCta />
      </main>
      <Footer />
      <StickyCta />
    </div>
  )
}
